// extracted by mini-css-extract-plugin
export default {"iconButton":"SidePanelWithIconButton_iconButton__g6dE5","header":"SidePanelWithIconButton_header__3JkYO","drawer":"SidePanelWithIconButton_drawer__3B0JH"};